import { ErrorInfo } from '@csp/csp-common-model';
import { ErrorInfoState, useErrorInfo as useErrorInfoInternal } from '@csp/fe-hooks';
import { ErrorService } from '@csp/web-common';
import { useGetErrorMessage } from './useGetErrorMessage';

export const useErrorInfo = (initialError?: ErrorInfo): ErrorInfoState => {
  const getErrorMessage = useGetErrorMessage();
  return useErrorInfoInternal({ initialError, errorHandler: ErrorService.handleError, getErrorMessage });
};
